import { createSlice } from "@reduxjs/toolkit";
import { _TOKEN_ } from "const";

const initialState = {
  loading: false,
  forceHideAllMenu: false,
  ssoError: false,
  [_TOKEN_]: null,
};

const slice = createSlice({
  initialState,
  name: "auth",
  reducers: {
    setAuthenticating: (state, { payload }) => {
      state.loading = payload;
    },
    signIn: (state, action) => {
      state.loading = true;
      state.username = action.payload.username;
    },
    signInSuccess: (state, action) => {
      state.loading = false;
      state[_TOKEN_] = action.payload.token;
      state.program = action.payload.program;
      state.programState = action.payload.programState;
    },
    signInFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    hideAllMainMenu: (state) => {
      state.forceHideAllMenu = true;
    },
    showAllMainMenu: (state) => {
      state.forceHideAllMenu = false;
    },
    signOut: () => initialState,
    terminated: () => {},
    flagSsoError: (state) => {
      state.ssoError = true;
    },
  },
});

export const {
  setAuthenticating,
  signIn,
  signInSuccess,
  signInFailure,
  signOut,
  terminated,
  hideAllMainMenu,
  showAllMainMenu,
  flagSsoError,
} = slice.actions;

export default slice.reducer;
